/**
 * Created by Rodrigo Quesada on 21/12/16.
 */
import {Validator} from '@angular/forms';
import {ValidationMessage} from './form-validator.class';

export interface CustomValidator extends Validator {
}

export class ValidationError {

    readonly message: string;

    constructor(message: string|ValidationMessage, readonly critical = true) {
        this.message = message instanceof ValidationMessage ? message.getMessage(critical) : message;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/custom-validator.class.ts